module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/bg-mv-b00c548eaf64c37c25eb422559d79e06.svg";